export class Const {
  static readonly SEED_RATE = 10000;
  static readonly POINT_RATE = 10000;
  static readonly ENTRY_POINT = 5;
  static readonly COMPANY_ENTRY_POINT = 150;
  static readonly MAX_RANKING_ELIGIBLE_AMOUNT = 200000;
}
